\
<template>
  <div class="bg-image">
    <div class="row">
      <div class="col-12">
        <main_header />
      </div>
    </div>
    <div class="responsive-layout mx-auto">
      <div class="row">
        <div class="col-12 mx-auto">
          <main_filter />
          <div class="col-12"></div>
          <name_section
            class="mb-3"
            subtitle="ทุกชุมชน ทุกกลุ่มชนิดพืช ทุกภูมิปัญญา"
            title="สัดส่วนข้อมูลแต่ละกลุ่มชนิดพืช"
            type="general"
          />
          <b-row class="">
            <b-col lg="6" md="6" sm="12" class="my-auto mx-auto">
              <bar_chart_horizontal chart="'5'" />
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="12"
              style="
                border: 1px solid #e5e5e5;
                box-sizing: border-box;
                box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                border-radius: 5px;
              "
            >
              <type_detail />
            </b-col>
          </b-row>
          <br />
        </div>
        <div class="col-12 mx-auto">
          <name_section
            subtitle="ทุกชุมชน ทุกกลุ่มชนิดพืช ทุกภูมิปัญญา"
            title="กราฟแสดงภาพพืชในแต่ละชุมชน"
            type="general"
          />
          <div style="border: 1px solid #e5e5e5">
            <network_chart />
          </div>
        </div>
        <div class="col-12 mx-auto">
          <div class="row">
            <div class="col col-lg-6 col-md-12 col-sm-12 col-12">
              <name_section
                class="mb-2"
                subtitle="ทุกชุมชน ทุกกลุ่มชนิดพืช ทุกภูมิปัญญา"
                title="ข้อมูลพันธุกรรมในแต่ละพื้นที่"
                type="general"
              />
              <map_chart />
            </div>
            <div
              class="col col-lg-6 col-md-12 col-sm-12 col-12 p-0 m-0 mx-auto"
            >
              <name_section
                class="mb-5"
                subtitle="ทุกชุมชน ทุกกลุ่มชนิดพืช ทุกภูมิปัญญา"
                title="เปรียบเทียบข้อมูลแปลงสำรวจและแปลงธนาคาร"
                type="general"
              />
              <bar_chart />
            </div>
          </div>
          <br />
        </div>
        <div class="col-12 mx-auto">
          <name_section
            subtitle="ทุกชุมชน ทุกกลุ่มชนิดพืช ทุกภูมิปัญญา"
            title="WORD CLOUD ข้อมูลพันธุกรรม"
            type="general"
          />
          <word_cloud />
        </div>
        <div class="col-12 mx-auto mb-5">
          <name_section
            subtitle="การเผยแพร่เอกสาร"
            title="เอกสาร"
            type="general"
          />
          <document :document="document" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import main_header from "@/components/main_heder";
import main_filter from "@/components/main_filter";
import bar_chart_horizontal from "@/components/bar_chart_horizontal";
import network_chart from "@/components/network_chart";
import map_chart from "@/components/map_chart";
import bar_chart from "@/components/bar_chart";
import word_cloud from "@/components/word_cloud";
import name_section from "@/components/name_section";
import type_detail from "@/components/type_detail";
import { mapState } from "vuex";
import Document from "@/components/document";

export default {
  name: "Home",
  components: {
    Document,
    main_header,
    main_filter,
    bar_chart_horizontal,
    network_chart,
    map_chart,
    bar_chart,
    word_cloud,
    name_section,
    type_detail,
  },
  data() {
    return {
      document: [],
    };
  },
  created() {
    this.checkLogin();
    this.getData();
  },
  computed: {
    ...mapState({
      accessToken: (state) => state.AuthModule.accessToken,
    }),
  },
  methods: {
    checkLogin() {
      // if (this.accessToken) {
      //   console.log("yes");
      //   // let path = "/";
      //   // if (this.$route.path !== path) this.$router.push(path);
      // } else {
      //   console.log("no");
      //   // let path = "/login";
      //   // if (this.$route.path !== path) this.$router.push(path);
      // }
    },
    getData() {
      let data = {
        community: "",
        category: "",
        knowledge: "",
      };
      this.$store.dispatch("dashboardModule/setDataFE", data);
      let doc = {
        take: 5,
      };
      this.$store.dispatch("dashboardModule/documentIndex", doc).then((res) => {
        this.document = res;
      });
    },
  },
};
</script>
<style>
.section_general_topic {
  margin-top: 20px;
}
</style>
